module.exports = __webpack_public_path__ + "img/shanghai.45fb5d8b.jpg";